import { render, staticRenderFns } from "./msw-support-cases.vue?vue&type=template&id=351fe100&"
import script from "./msw-support-cases.vue?vue&type=script&lang=ts&"
export * from "./msw-support-cases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports